module.exports = "<span>Wersja: 1.000</span>\n<div *ngIf=\"isAuthenticated\">\n    <span>Użytkownik:</span>\n    <span>{{userName}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/status-bar/status-bar.component.html
// module id = ./src/app/components/status-bar/status-bar.component.html
// module chunks = main